<template>
  <v-card>
    <v-card-title>
      <span class="title font-weight-light">ผลการพิจารณา</span>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-container fluid grid-list-md>
        <v-layout row wrap>
          <v-flex xs12 md4>
            <v-subheader class="orange--text"><strong>ประธานรายวิชา/อ.ประจำวิชา</strong></v-subheader>
          </v-flex>
          <v-flex xs12 md4>
            <v-select
              :items="statusItems"
              v-model="form.instructorStatus"
              label="สถานะ"
              item-text="text"
              item-value="value"
            ></v-select>
          </v-flex>
          <v-flex xs12 md4>
            <v-menu
              :close-on-content-click="false"
              v-model="menuInstructorDate"
              :nudge-top="30"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              max-width="290px"
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                :value="date(form.instructorStatusDate)" 
                label="วันที่"
                prepend-icon="event"
                readonly
                outline
              ></v-text-field>
              <v-date-picker 
                v-model="form.instructorStatusDate" 
                no-title 
                locale="th-Th"
                @input="menuInstructorDate = false"></v-date-picker>
            </v-menu>
          </v-flex>

          <v-flex xs12 md4>
            <v-subheader class="orange--text"><strong>หัวหน้าสำนักงาน</strong></v-subheader>
          </v-flex>
          <v-flex xs12 md4>
            <v-select
              :items="statusItems"
              v-model="form.officerStatus"
              label="สถานะ"
              item-text="text"
              item-value="value"
            ></v-select>
          </v-flex>
          <v-flex xs12 md4>
            <v-menu
              :close-on-content-click="false"
              v-model="menuOfficerDate"
              :nudge-top="30"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              max-width="290px"
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                :value="date(form.officerStatusDate)" 
                label="วันที่"
                prepend-icon="event"
                readonly
                outline
              ></v-text-field>
              <v-date-picker 
                v-model="form.officerStatusDate" 
                no-title 
                locale="th-Th"
                @input="menuOfficerDate = false"></v-date-picker>
            </v-menu>
          </v-flex>

          <v-flex xs12 md4>
            <v-subheader class="orange--text"><strong>คณบดี</strong></v-subheader>
          </v-flex>
          <v-flex xs12 md4>
            <v-select
              :items="statusItems"
              v-model="form.deanStatus"
              label="สถานะ"
              item-text="text"
              item-value="value"
            ></v-select>
          </v-flex>
          <v-flex xs12 md4>
            <v-menu
              :close-on-content-click="false"
              v-model="menuDeanDate"
              :nudge-top="30"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              max-width="290px"
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                :value="date(form.deanStatusDate)" 
                label="วันที่"
                prepend-icon="event"
                readonly
                outline
              ></v-text-field>
              <v-date-picker 
                v-model="form.deanStatusDate" 
                no-title 
                locale="th-Th"
                @input="menuDeanDate = false"></v-date-picker>
            </v-menu>
          </v-flex>
        </v-layout>
      </v-container> 
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <slot></slot>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: ['form'],
  data () {
    return {
      menuInstructorDate: false,
      menuOfficerDate: false,
      menuDeanDate: false,
      statusItems: [
        { text: '', value: null },
        { text: 'รับทราบ', value: 'ACKNOWLEDGE' },
        { text: 'อนุมัติ', value: 'APPROVED' },
        { text: 'ไม่อนุมัติ', value: 'DENIED' }
      ]
    }
  },
  computed: {
    ...mapGetters({
      facultyItems: 'university/facultyItems',
      courseTypeItems: 'activeCourse/courseTypeItems',
      requestTypeItems: 'requestType/requestTypeItems',
      subjectItems: 'subject/subjectItems'
    })
  },
  mounted () {
    console.log("mounted...")
  },
  methods: {
    date (val) {
      return this.$options.filters.formatFullDate(val)
    },
  }
}
</script>


// WEBPACK FOOTER //
// src/components/management/student/formProcess.vue